import { render, staticRenderFns } from "./AddRoleManage.vue?vue&type=template&id=bde3d380"
import script from "./AddRoleManage.vue?vue&type=script&lang=js"
export * from "./AddRoleManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports